import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountInfoService, AuthDataModel, SessionInfoService, AlertsService } from 'degarmo-lib';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private sessionInfoService: SessionInfoService,
    private accountInfoService: AccountInfoService,
    private alertService: AlertsService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //console.log('AuthenticationGuard#canActivate called');
    const auth: AuthDataModel = this.sessionInfoService.getAuthenticationInformation();
    const account = this.accountInfoService.data.account;

    // Skip auth check if route is marked to skip
    // Log route data in a more readable format
    //console.log('Route data:', JSON.stringify(next.data, null, 2));
    //console.log('Current URL:', state.url);

    const hasInterviewGuideHash = state.url.includes('#/interview/interview-guide/digital/start');
    if (hasInterviewGuideHash) {
      //console.log('Interview guide route detected - AG allowing access');
      return true;
    }

    if (account && Object.keys(account).length === 0) {
      this.router.navigate(['/account/login']);
      return false;
    }

    // check for multi auth
    if (account && account.twoFactorAuthentication === true) return false;

    if (auth && auth.isLoggedIn) return true;
    else {
      this.router.navigate(['/account/login']);
      return false;
    }
  }
}
